import { OwnerTypes } from "constants/aggrid";

export const OrderedSavedViewOwnerTypes = [
  OwnerTypes.GLOBAL,
  OwnerTypes.SALEYARD,
  OwnerTypes.DEPLOYMENT,
  OwnerTypes.USER,
];

export const sortSavedViewCategories = (a, b) => {
  return (
    OrderedSavedViewOwnerTypes.indexOf(a) -
    OrderedSavedViewOwnerTypes.indexOf(b)
  );
};

// Matches the scope the backend's SavedView.unique_together enforces
// (owner + name, within whatever table `views` has already been filtered to)
// - a match here means saving under `name` as a new view would 400.
export const findMatchingSavedView = (views, name, owner) =>
  views.find(
    view =>
      view.name === name &&
      view.ownerType === owner.ownerType &&
      String(view.ownerId) === String(owner.ownerId),
  ) || null;
